export const reverseGeocode = async (
  lat: number,
  lng: number,
): Promise<string> => {
  try {
    const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&language=pt-BR&key=${apiKey}`,
    );

    if (!response.ok) throw new Error("Google Geocoding request failed");

    const data = await response.json();

    if (data.results && data.results.length > 0) {
      return data.results[0].formatted_address;
    }

    return `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
  } catch {
    return `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
  }
};

/**
 * Verifica se um texto de endereço parece ser apenas coordenadas
 * (ex: "-3.758835, -40.813450" ou "-3.758835,-40.813450")
 */
export const isCoordinateAddress = (address: string): boolean => {
  if (!address) return false;
  const trimmed = address.trim();
  return /^-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/.test(trimmed);
};
